import styled from 'styled-components';
import { Form as FormBase } from '@unform/web';
import { Table as GlobalTable } from 'styles/global';

interface FormGroupsProps {
  $columns: string;
}
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;

  > div {
    > button {
      align-self: flex-end;
      margin-top: 10px;
      padding: 0 15px 0 15px;
      width: 150px;
    }
  }
  .ButtonGroup {
    display: flex;
    justify-content: space-between;
    margin: 0 1rem;
  }
  header {
    align-items: baseline;
    > button {
      margin-right: 10px;
    }
  }
`;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 0 15px 0 15px;
  justify-content: space-between;
  section {
    white-space: nowrap;
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;

export const Table = styled(GlobalTable)`
  th {
    &:nth-of-type(2) {
      text-align: left;
    }
    &:nth-of-type(3) {
      width: 10rem;
      text-align: center;
    }
    &:nth-of-type(4) {
      width: 150px;
      text-align: center;
    }
  }
  td {
    &:nth-of-type(2) {
      text-align: left;
    }
    &:nth-of-type(3) {
      width: 10rem;
      text-align: center;
    }
    &:nth-of-type(4) {
      width: 150px;
      justify-items: center;
    }
  }
`;

export const FormGroups = styled.div<FormGroupsProps>`
  grid-template-columns: ${props => props.$columns};
  display: grid;
  > div {
    margin-top: 10px;
    &:not(:first-of-type) {
      margin-left: 5px;
    }
  }
`;

export const NovoInfo = styled.div`
  p {
    margin-bottom: 1.5rem;
  }
  div {
    display: flex;
    justify-content: center;
  }
`;
